export default "https://cdn-static.gokick.com/assets/5330764b9b84e4374a94f4eff9433164072ac9e6/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";